var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWinterGrip = function SvgWinterGrip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.776 4 22 20H5.552l.001-.005H2L8.326 7.689l1.777 3.456z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15h3m-8 0h3m1.5-.866 1.5-2.598m-4 6.928 1.5-2.598M12.5 14.134 11 11.536m4 6.928-1.5-2.598"
  }))));
};
export { SvgWinterGrip as ReactComponent };
export default __webpack_public_path__ + "e521f3e9eb2f0231110bde0fbaa3fdbe.svg";